'use client';

import Script from 'next/script';

export default function TallyScript() {
  return <Script 
    src="https://tally.so/widgets/embed.js" 
    defer async 
    id="tally-js"
    onLoad={() => {
      eval('Tally.loadEmbeds()')
    }}
    onReady={() => { 
      eval('Tally.loadEmbeds()') 
    }}
  />;
}
